import ggCustomerLg1Img from "../assets/img/customer-gg-large-1.png";
import ggCustomerLg1ImgWebp from "../assets/img/customer-gg-large-1.webp";
import ggCustomerLg2Img from "../assets/img/customer-gg-large-2.png";
import ggCustomerLg2ImgWebp from "../assets/img/customer-gg-large-2.webp";
import ggCustomerLg3Img from "../assets/img/customer-gg-large-3.png";
import ggCustomerLg3ImgWebp from "../assets/img/customer-gg-large-3.webp";
import ggCustomerLg4Img from "../assets/img/customer-gg-large-4.png";
import ggCustomerLg4ImgWebp from "../assets/img/customer-gg-large-4.webp";
import ggCustomerLg5Img from "../assets/img/customer-gg-large-5.png";
import ggCustomerLg5ImgWebp from "../assets/img/customer-gg-large-5.webp";
import ggCustomerLg6Img from "../assets/img/customer-gg-large-6.png";
import ggCustomerLg6ImgWebp from "../assets/img/customer-gg-large-6.webp";
import ggCustomerLg7Img from "../assets/img/customer-gg-large-7.png";
import ggCustomerLg7ImgWebp from "../assets/img/customer-gg-large-7.webp";
import ggCustomerLg8Img from "../assets/img/customer-gg-large-8.png";
import ggCustomerLg8ImgWebp from "../assets/img/customer-gg-large-8.webp";
import ggCustomerLg9Img from "../assets/img/customer-gg-large-9.png";
import ggCustomerLg9ImgWebp from "../assets/img/customer-gg-large-9.webp";
import ggCustomerLg10Img from "../assets/img/customer-gg-large-10.png";
import ggCustomerLg10ImgWebp from "../assets/img/customer-gg-large-10.webp";
import ggCustomerLg11Img from "../assets/img/customer-gg-large-11.png";
import ggCustomerLg11ImgWebp from "../assets/img/customer-gg-large-11.webp";
import ggCustomerLg12Img from "../assets/img/customer-gg-large-12.png";
import ggCustomerLg12ImgWebp from "../assets/img/customer-gg-large-12.webp";

import { TestimonialLarge } from "../types/testimonial";

export const mainPageLgTestimonials: TestimonialLarge[] = [
    { img: ggCustomerLg3Img, imgWebp: ggCustomerLg3ImgWebp },
    { img: ggCustomerLg2Img, imgWebp: ggCustomerLg2ImgWebp },
    { img: ggCustomerLg1Img, imgWebp: ggCustomerLg1ImgWebp },
    { img: ggCustomerLg4Img, imgWebp: ggCustomerLg4ImgWebp },
];

export const upsellGg6PageLgTestimonials: TestimonialLarge[] = [
    { img: ggCustomerLg7Img, imgWebp: ggCustomerLg7ImgWebp },
    { img: ggCustomerLg8Img, imgWebp: ggCustomerLg8ImgWebp },
    { img: ggCustomerLg5Img, imgWebp: ggCustomerLg5ImgWebp },
    { img: ggCustomerLg6Img, imgWebp: ggCustomerLg6ImgWebp },
];

export const downsellGg3PageLgTestimonials: TestimonialLarge[] = [
    { img: ggCustomerLg7Img, imgWebp: ggCustomerLg7ImgWebp },
    { img: ggCustomerLg8Img, imgWebp: ggCustomerLg8ImgWebp },
    { img: ggCustomerLg5Img, imgWebp: ggCustomerLg5ImgWebp },
    { img: ggCustomerLg6Img, imgWebp: ggCustomerLg6ImgWebp },
];

export const testimonialPageLgTestimonials: TestimonialLarge[] = [
    { img: ggCustomerLg12Img, imgWebp: ggCustomerLg12ImgWebp },
    { img: ggCustomerLg3Img, imgWebp: ggCustomerLg3ImgWebp },
    { img: ggCustomerLg9Img, imgWebp: ggCustomerLg9ImgWebp },
    { img: ggCustomerLg5Img, imgWebp: ggCustomerLg5ImgWebp },
    { img: ggCustomerLg11Img, imgWebp: ggCustomerLg11ImgWebp },
    { img: ggCustomerLg8Img, imgWebp: ggCustomerLg8ImgWebp },
    { img: ggCustomerLg10Img, imgWebp: ggCustomerLg10ImgWebp },
    { img: ggCustomerLg2Img, imgWebp: ggCustomerLg2ImgWebp },
];